module.exports = __webpack_public_path__ + "create-project-hero.svg";